import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/images/ws-creation-success-image.png'


const _withScopeId = n => (_pushScopeId("data-v-4568b169"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-gap-4 rmd:tw-gap-10" }
const _hoisted_2 = { class: "header-title" }
const _hoisted_3 = { class: "!tw-capitalize" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-sub-title" }, " You have successfully created your Trade Workstation. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom__modal__img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Create Workstation"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewWorkstationSubscriptionModal = _resolveComponent("NewWorkstationSubscriptionModal")!
  const _component_Text = _resolveComponent("Text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_commonDialog = _resolveComponent("commonDialog")!
  const _component_PaymentStatusModal = _resolveComponent("PaymentStatusModal")!
  const _component_KYCStatusModal = _resolveComponent("KYCStatusModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isShowSoleTraderWorkStationModal)
      ? (_openBlock(), _createBlock(_component_NewWorkstationSubscriptionModal, {
          key: 0,
          onOnClickPaymentPlan: $setup.onClickPaymentPlan,
          isLoading: $setup.monthlyPlanLoading || $setup.yearlyPlanLoading,
          onCloseModal: $setup.onHandleClickClose
        }, null, 8, ["onOnClickPaymentPlan", "isLoading", "onCloseModal"]))
      : _createCommentVNode("", true),
    _createVNode(_component_commonDialog, {
      modelValue: $setup.isShowSuccessfullModal,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.isShowSuccessfullModal) = $event)),
      isShowHeader: false,
      isShowBackButton: false,
      width: "465px",
      "max-width": "100%",
      height: "auto",
      persistent: "",
      className: ['solo-trader__last__step__box', 'workstation_create_modal']
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_2, [
              _createTextVNode(" Great job, "),
              _createElementVNode("span", _hoisted_3, _toDisplayString($setup.activeUserWorkstation?.user?.firstName ||
                $setup.activeUserWorkstation?.name), 1)
            ]),
            _hoisted_4
          ]),
          _hoisted_5,
          _createVNode(_component_Text, {
            variant: "h6",
            textWeight: "400",
            textColor: "rgba(12, 15, 74, 0.5)"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Time to take your business sky high and supercharge your skills! Start by completing your Trade Passport.")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_v_btn, {
          class: "button button-orange !tw-mt-[16px] rmd:!tw-mt-[24px]",
          size: "large",
          block: "",
          onClick: $setup.onClickSoloTraderDashboard
        }, {
          default: _withCtx(() => [
            _createTextVNode(" continue 🚀 ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    ($setup.statusModal.PAYMENT === $setup.currentStatusModalName)
      ? (_openBlock(), _createBlock(_component_PaymentStatusModal, {
          key: 1,
          onContinue: $setup.onClickStatusModalContinue,
          paymentStatus: $setup.currentModalStatus,
          planType: $setup.planType
        }, null, 8, ["onContinue", "paymentStatus", "planType"]))
      : _createCommentVNode("", true),
    ($setup.statusModal.KYC === $setup.currentStatusModalName)
      ? (_openBlock(), _createBlock(_component_KYCStatusModal, {
          key: 2,
          onContinue: $setup.onClickTermAndConditionNext,
          kycStatus: $setup.currentModalStatus
        }, null, 8, ["onContinue", "kycStatus"]))
      : _createCommentVNode("", true)
  ], 64))
}